import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

export function useNavigateWithScroll() {
  const navigate = useNavigate();

  return useCallback((path : string) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // ou 'auto'
  }, [navigate]);
}